import "core-js/modules/es6.array.find";
import { toQueryString } from '@ykz/ykz-util/base';
export default {
  name: 'shopNav',
  props: {
    firstType: {
      default: '-5'
    }
  },
  data: function data() {
    return {
      weChatId: window.getUrlParams('weChatId'),
      fromWeChatId: window.getUrlParams('fromWeChatId'),
      navList: [{
        id: '-5',
        name: '热门'
      }, {
        id: '6',
        name: '附近'
      }, {
        id: '2',
        name: '最新'
      }, {
        id: '1',
        name: '预告'
      }],
      selectId: '',
      navLeft: 0,
      navFloat: false
    };
  },
  methods: {
    selectItem: function selectItem(item, type) {
      if (item.id != this.selectId) {
        this.selectId = item.id;
        this.navLeft = $('#shopNav_' + item.id).offset().left + $('#shopNav_' + item.id).width() * 0.5;
        this.$emit('update', {
          id: this.selectId,
          type: type
        });
      }
    },
    goSearch: function goSearch() {
      var that = this;
      var param = {
        weChatId: that.weChatId,
        fromWeChatId: that.fromWeChatId,
        keyWords: '',
        simData: that.simData || null
      };
      // 大数据锚点(点击产品列表)
      YCF_Plugin.reportUserAnchors({
        event_id: '500074',
        page_name: '首页'
      }).always(function () {
        window.location.href = '/front/promoter/promoterSearch?' + toQueryString(param);
      });
    }
  },
  mounted: function mounted() {
    var that = this;
    var selectItem = that.navList.find(function (item) {
      return item.id == (that.firstType || '-5');
    });
    that.selectItem(selectItem, 1);
  }
};